import * as yup from "yup";

export const stepBedsSchema = yup.object().shape({
    name: yup
        .string()
        .required('Campo obbligatorio'),
    beds: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
    sofaBeds: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
    extraBeds: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio')
})

export const stepInfoSchema = yup.object().shape({
    mq: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
    numberOfBathroom: yup.number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
    apartmentTypologyId: yup
        .string()
        .required('Campo obbligatorio'),
    apartmentCategoryId: yup
        .string()
        .required('Campo obbligatorio'),
});